import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInformation: {
        id: 'ml.quoteandbind.pa.additionalInformation.Additional Information',
        defaultMessage: 'Additional Information',
    },
    driverError: {
        id: 'ml.quoteandbind.pa.additionalInformation.Driver Error',
        defaultMessage: 'Excluded Drivers or household members marked with (!) need your attention'
    },
    houseAdditionalInformation: {
        id: 'ml.quoteandbind.pa.additionalInformation.HouseAdditionalInformation',
        defaultMessage: 'Additional Information'
    },
    weWillReviewYourQuoteNext: {
        id: 'ml.quoteandbind.pa.additionalInformation.We\'ll review your quote next',
        defaultMessage: 'We\'ll {reviewYourQuote} next'
    },
    reviewYourQuote: {
        id: 'ml.quoteandbind.pa.additionalInformation.review your quote',
        defaultMessage: 'review your quote'
    },
    vehiclePercentageDriverError: {
        id: 'ml.quoteandbind.pa.additionalInformation.One or more drivers have not been assigned as the highest percentage on a vehicle',
        defaultMessage: 'One or more drivers have not been assigned as the highest percentage on a vehicle'
    },
    vehiclePrimaryDriverError: {
        id: 'ml.quoteandbind.pa.additionalInformation.One or more drivers have not been assigned as a principal driver on a vehicle',
        defaultMessage: 'One or more drivers have not been assigned as a principal driver on a vehicle'
    },
    totalPercentageError: {
        id: 'ml.quoteandbind.pa.additionalInformation.Total for each vehicle must equal 100',
        defaultMessage: 'Total for each vehicle must equal 100'
    },
    assignmentRequiredError: {
        id: 'ml.quoteandbind.pa.additionalInformation.One or more vehicles have not been assigned with a principal driver',
        defaultMessage: 'One or more vehicles have not been assigned with a principal driver'
    },
    reviewIdentifiedFields: {
        id: 'ml.quoteandbind.pages.additionalinfo.hvq.Review the below identified fields',
        defaultMessage: 'Review the below identified fields'
    },
    verifyPrefilledInfo: {
        id: 'ml.quoteandbind.pages.additionalinfo.hvq.Verify the information we prefilled for you',
        defaultMessage: 'Verify the information we prefilled for you'
    },
    hvqNextDesc: {
        id: 'ml.quoteandbind.pages.additionalinfo.hvq.We\'ll gather {finalVehicleAndDriverDetails} next',
        defaultMessage: 'We\'ll gather {finalVehicleAndDriverDetails} next'
    },
    hvqFinalVehAndDriverDetails: {
        id: 'ml.quoteandbind.pages.additionalinfo.hvq.some final vehicle and driver details',
        defaultMessage: 'some final vehicle and driver details'
    },
    helptext:{
        id:'ml.quoteandbind.pa.additionalInformation.What does this mean',
        defaultMessage:'What does this mean?'
    },
    helptextMap:{
        id:'ml.quoteandbind.pa.additionalInformation.newPolicySameLocation',
        defaultMessage:'You are purchasing a new policy for the same location but with different type of coverage.  For example, purchasing the home you were previously renting.'
    },
    prriorInsuranceQnBMessage: {
        "id": "ml.quoteandbind.pa.additionalInformation.Consumer Prior Insurance Message",
        "defaultMessage": "The Prior Insurance information on this screen is from your prior policy with us, or from another insurance carrier’s information on a consumer report.  Any field that contains this information cannot be changed.  For questions or to dispute the information from a prior policy with us, please contact us.  For questions or to dispute information from another insurance carrier, contact the LexisNexis Consumer Service Center by phone at 800-456-6004, by mail at PO Box 105108 Atlanta, GA 30348-5108, or online at www.consumerdisclosure.com."
    },
    highestLevelOfEducation_ML: {
        id:'ml.quoteandbind.pa.additionalInformation.highestLevelOfEducation_ML',
        defaultMessage:'Answer Highest Level Of Education Question'
    },
    maxNumberOfSpouseAllowed_ML: {
        id:'ml.quoteandbind.pa.additionalInformation.maxNumberOfSpouseAllowed_ML',
        defaultMessage:'Spouse has already been identified on another driver'
    }
});
